import { toast } from "react-toastify";
import { useMemo } from "react";

export function usePropostaToast() {
  return useMemo(
    () => ({
      info: (text: string, description?: string) => {
        toast.info(description ? `${text} ${description}` : text);
      },
      error: (text: string, description?: string) => {
        toast.error(description ? `${text} ${description}` : text);
      },
      success: (text: string) => {
        toast.success(text);
      },
    }),
    [],
  );
}
